import { orders } from 'Pages/orders'
import { dashboardConstants } from 'Pages/dashboard'

export const ActionTypes = {
	...orders,
	...dashboardConstants,
}
